(() => {
  let root = document.querySelector('#root');

  if (root) root.dataset.dfGalleryReady = 'false';

  const getRoot = () => {
    const currentRoot = document.querySelector('#root');
    if (currentRoot) root = currentRoot;
    return root;
  };

  const getTodayDate = () => new Intl.DateTimeFormat('pt-BR', {
    timeZone: 'America/Sao_Paulo',
    day: '2-digit',
    month: '2-digit'
  }).format(new Date());

  const replaceText = () => {
    const today = getTodayDate();
    const walker = document.createTreeWalker(root.parentElement || root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    let node;
    while ((node = walker.nextNode())) nodes.push(node);
    nodes.forEach((textNode) => {
      const nextValue = textNode.nodeValue
        .replace(/Boom\s*Boom\s*Up/gi, 'Dermafix')
        .replace(/Peach\s*Up/gi, 'Attracione')
        .replace(/(at(?:\u00e9) hoje,\s*)\d{1,2}\/\d{1,2}/gi, '$1' + today)
        .replace(/Comprar\s+Agora/gi, 'Adicionar ao Carrinho')
        .replace(/\bCOMPRAR\b/gi, 'Adicionar ao Carrinho')
        .replace(/Registro\s+Anvisa\s*:\s*[0-9./-]+/gi, 'ANVISA: 25351.120164/2026-41')
        .replace(/Espátula/gi, '')
        .replace(/(?:ENTREGA\s+FULL\s*(?:[-\/\u2013\u2014:]\s*)?Chegar(?:\u00E1|\u00C3\u00A1)\s+em\s+2\s+a\s+4\s+dias|Chegar(?:\u00E1|\u00C3\u00A1)\s+em\s+2\s+a\s+4\s+dias)/gi, 'Prioridade m\u00E1xima no envio');
      if (nextValue !== textNode.nodeValue) textNode.nodeValue = nextValue;
    });
    root.dataset.dfTodayDate = today;
    const deliveryLabel = Array.from((root.parentElement || root).querySelectorAll('span.font-bold'))
      .find((element) => element.textContent.trim().replace(/\s+/g, ' ') === 'ENTREGA FULL');
    if (deliveryLabel) {
      const parent = deliveryLabel.parentElement;
      deliveryLabel.remove();
      parent?.childNodes.forEach((child) => {
        if (child.nodeType === Node.TEXT_NODE) {
          child.nodeValue = child.nodeValue.replace(/^\s*[-\/\u2013\u2014:]\s*/, '');
        }
      });
    }
  };

  const removeShareButton = () => {
    root.querySelectorAll('button').forEach((button) => {
      if (button.querySelector('.lucide-share-2, .lucide-share2')) button.remove();
    });
  };

  const removeLegacyChrome = () => {
    root.querySelector('.bg-orange-500.text-white.w-full')?.remove();
    root.querySelector('main > .min-h-screen > header')?.remove();
    root.querySelectorAll('footer').forEach((footer) => footer.remove());
  };

  const rebuildGallery = () => {
    const images = Array.isArray(window.DF_PRODUCT_GALLERY) ? window.DF_PRODUCT_GALLERY : [];
    const gallery = root.querySelector('[data-df-gallery]');
    const track = root.querySelector('[data-df-gallery-track]');
    if (!gallery || !track || !images.length) return false;
    const signature = JSON.stringify(images.map((image) => [image.src, image.alt, image.width, image.height]));
    if (track.dataset.dfGallerySignature === signature) return true;
    track.replaceChildren(...images.map((image, index) => {
      const slide = document.createElement('div');
      slide.style.cssText = 'flex:0 0 100%;min-width:100%;max-width:100%;width:100%;box-sizing:border-box;position:relative;overflow:hidden;';
      const img = document.createElement('img');
      img.src = normaliseUrl(image.src);
      img.alt = image.alt || `Imagem do produto ${index + 1}`;
      img.width = image.width || 1000;
      img.height = image.height || 1000;
      img.loading = index === 0 ? 'eager' : 'lazy';
      img.decoding = 'async';
      img.draggable = false;
      img.className = 'w-full h-auto object-contain select-none pointer-events-none';
      img.style.display = 'block';
      slide.append(img);
      return slide;
    }));
    const dots = track.nextElementSibling;
    if (dots) {
      dots.replaceChildren(...images.map((_, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.dataset.dfDot = String(index);
        dot.setAttribute('aria-label', `Imagem ${index + 1}`);
        dot.className = `transition-all rounded-full ${index === 0 ? 'bg-orange-500 w-6 h-1.5' : 'bg-gray-300 w-1.5 h-1.5'}`;
        return dot;
      }));
    }
    const thumbRow = root.querySelector('[data-df-thumb]')?.parentElement;
    if (thumbRow) {
      thumbRow.replaceChildren(...images.map((image, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.dfThumb = String(index);
        button.className = `shrink-0 w-16 h-16 rounded-lg overflow-hidden transition-all ${index === 0 ? 'ring-2 ring-orange-500 shadow-md opacity-100' : 'opacity-50'}`;
        const img = document.createElement('img');
        img.src = normaliseUrl(image.src);
        img.alt = `Thumb ${index + 1}`;
        img.width = image.width || 1000;
        img.height = image.height || 1000;
        img.loading = 'lazy';
        img.draggable = false;
        img.className = 'w-full h-full object-cover';
        button.append(img);
        return button;
      }));
    }
    track.dataset.dfGallerySignature = signature;
    return true;
  };

  const normaliseUrl = (value) => {
    const source = String(value || '');
    if (source.startsWith('//')) return `https:${source}`;
    if (source.startsWith('https:') && !source.startsWith('https://')) return source.replace(/^https:/, 'https://');
    if (source.startsWith('/')) return `${window.location.origin}${source}`;
    if (source.startsWith('http://') || source.startsWith('https://')) return source;
    return `https://${source}`;
  };

  const getProductMedia = (index) => {
    const images = Array.isArray(window.DF_PRODUCT_GALLERY) ? window.DF_PRODUCT_GALLERY : [];
    const media = images[index];
    if (media?.src) return { src: normaliseUrl(media.src), alt: media.alt || `Imagem do produto ${index + 1}` };
    const fallback = getRoot()?.querySelector(`[data-df-gallery-track] > div:nth-child(${index + 1}) img`);
    if (!fallback) return null;
    return { src: normaliseUrl(fallback.currentSrc || fallback.src), alt: fallback.alt || `Imagem do produto ${index + 1}` };
  };

  const hideWomenVideos = () => {
    const videos = root.querySelectorAll('button[aria-label^="Reproduzir"]');
    const containers = new Set();
    videos.forEach((video) => {
      video.hidden = true;
      video.setAttribute('aria-hidden', 'true');
      const container = video.parentElement;
      if (!container) return;
      container.dataset.dfWomenVideos = 'true';
      containers.add(container);
    });
    containers.forEach((container) => {
      const wrapper = container.closest('[data-df-women-videos-section="true"]');
      const visibleMedia = Array.from(container.querySelectorAll('button, video, iframe, img')).some((element) => {
        if (element.hidden || element.getAttribute('aria-hidden') === 'true') return false;
        const style = window.getComputedStyle(element);
        const rect = element.getBoundingClientRect();
        return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
      });
      if (wrapper && !visibleMedia) {
        wrapper.dataset.dfEmptyMediaSlot = 'true';
        wrapper.hidden = true;
        wrapper.style.setProperty('display', 'none', 'important');
      }
      if (window.matchMedia?.('(max-width: 767px)').matches) {
        container.hidden = true;
        container.style.setProperty('display', 'none', 'important');
      }
    });
    root.dataset.dfWomenVideosHidden = String(videos.length);
  };

  const removeSpatulaCard = () => {
    const card = root.querySelector('#hero-purchase img[alt*="Esp"]')?.closest('.flex.flex-col');
    card?.remove();
  };

  const replaceBrandAttributes = () => {
    const pattern = /Boom\s*Boom\s*Up/gi;
    root.querySelectorAll('[alt], [title], [aria-label]').forEach((element) => {
      ['alt', 'title', 'aria-label'].forEach((attribute) => {
        const value = element.getAttribute(attribute);
        if (!value || !pattern.test(value)) return;
        element.setAttribute(attribute, value.replace(pattern, 'Dermafix'));
        pattern.lastIndex = 0;
      });
    });
  };

  const replaceReviewsSummary = () => {
    const summary = '4,9 · (1.778) · 16.800+ compras no mês passado';
    root.querySelectorAll('a[href="#df-reviews"]').forEach((link) => {
      if (!/Avaliações reais/i.test(link.textContent || '') && link.dataset.dfReviewSummary !== 'true') return;
      link.className = 'df-review-summary';
      link.dataset.dfReviewSummary = 'true';
      link.setAttribute('aria-label', `Avaliações: ${summary}`);
      const stars = document.createElement('span');
      stars.className = 'df-review-summary__stars';
      stars.setAttribute('aria-hidden', 'true');
      stars.textContent = '★★★★★';
      const copy = document.createElement('span');
      copy.className = 'df-review-summary__copy';
      copy.textContent = summary;
      link.replaceChildren(stars, copy);
    });
  };

  // Dermafix offer preview candidate: commercial backend still requires approval.
  const DERMAFIX_OFFERS = {"1": "<div class=\"space-y-3\" id=\"hero-purchase\"><div class=\"space-y-3\"><div><label class=\"relative block rounded-2xl border-2 cursor-pointer transition-all duration-200 select-none overflow-hidden border-gray-200 hover:border-orange-300 hover:shadow-sm\" data-df-offer-quantity=\"3\" for=\"bundle-3\"><input class=\"sr-only\" id=\"bundle-3\" name=\"bundle\" type=\"radio\" value=\"3\"/><div class=\"w-full text-white text-center font-bold flex items-center justify-center gap-1.5\" style=\"background-color: rgb(249, 115, 22); padding: 5px 8px; font-size: clamp(11px, 2.7vw, 13px);\"><svg aria-hidden=\"true\" class=\"lucide lucide-gift w-3.5 h-3.5 flex-shrink-0\" fill=\"none\" height=\"24\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" viewbox=\"0 0 24 24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12 7v14\"></path><path d=\"M20 11v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-8\"></path><path d=\"M7.5 7a1 1 0 0 1 0-5A4.8 8 0 0 1 12 7a4.8 8 0 0 1 4.5-5 1 1 0 0 1 0 5\"></path><rect height=\"4\" rx=\"1\" width=\"18\" x=\"3\" y=\"7\"></rect></svg><span class=\"whitespace-nowrap\">Oferta exclusiva de hoje</span><span class=\"whitespace-nowrap flex items-center gap-1\"><svg aria-hidden=\"true\" class=\"lucide lucide-clock w-3 h-3 flex-shrink-0\" fill=\"none\" height=\"24\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" viewbox=\"0 0 24 24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"12\" cy=\"12\" r=\"10\"></circle><path d=\"M12 6v6l4 2\"></path></svg>02:38:06</span></div><div class=\"px-3 py-3 sm:px-5 sm:py-5 bg-white\"><div class=\"flex items-center gap-3 sm:gap-5\"><div class=\"flex-shrink-0 w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors border-gray-300 bg-white\"></div><div class=\"flex-1 min-w-0\"><div class=\"flex items-center gap-2 flex-wrap\"><span class=\"font-bold leading-tight text-gray-900\" style=\"font-size: clamp(14px, 3.5vw, 17px); max-width: 100%;\">3 potes + e-book grátis</span><span class=\"border border-green-600 bg-green-50 text-green-700 font-bold rounded-full px-2 py-0.5 whitespace-nowrap flex-shrink-0\" style=\"font-size: clamp(10px, 2.4vw, 13px);\">-60% OFF</span></div><p class=\"text-gray-500 mt-0.5\" style=\"font-size: clamp(11px, 2.7vw, 13px);\">Melhor resultado com 3 potes</p><p class=\"text-gray-500 mt-0.5\" style=\"font-size: clamp(10px, 2.5vw, 12px);\">R$ 1,33/dia</p></div><div class=\"flex-shrink-0 text-right\"><p class=\"text-gray-400 line-through leading-none\" style=\"font-size: clamp(11px, 2.7vw, 13px);\">R$ 297,00</p><p class=\"font-extrabold leading-tight mt-0.5 text-orange-600\" style=\"font-size: clamp(18px, 4.8vw, 26px); line-height: 1.1;\">R$ 119,99</p><p class=\"text-gray-400 leading-none mt-0.5\" style=\"font-size: clamp(10px, 2.5vw, 12px);\">12x de R$ 14,06</p></div></div></div></label></div><div><label class=\"relative block rounded-2xl border-2 cursor-pointer transition-all duration-200 select-none overflow-hidden border-gray-200 hover:border-orange-300 hover:shadow-sm\" data-df-offer-quantity=\"2\" for=\"bundle-2\"><input class=\"sr-only\" id=\"bundle-2\" name=\"bundle\" type=\"radio\" value=\"2\"/><div class=\"px-3 py-3 sm:px-5 sm:py-5 bg-white\"><div class=\"flex items-center gap-3 sm:gap-5\"><div class=\"flex-shrink-0 w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors border-gray-300 bg-white\"></div><div class=\"flex-1 min-w-0\"><div class=\"flex items-center gap-2 flex-wrap\"><span class=\"font-bold leading-tight text-gray-900\" style=\"font-size: clamp(14px, 3.5vw, 17px); max-width: 100%;\">Somente 2 potes</span><span class=\"border border-green-600 bg-green-50 text-green-700 font-bold rounded-full px-2 py-0.5 whitespace-nowrap flex-shrink-0\" style=\"font-size: clamp(10px, 2.4vw, 13px);\">-55% OFF</span></div><p class=\"text-gray-500 mt-0.5\" style=\"font-size: clamp(11px, 2.7vw, 13px);\">Rotina inicial · 2 potes • 60 dias de uso</p></div><div class=\"flex-shrink-0 text-right\"><p class=\"text-gray-400 line-through leading-none\" style=\"font-size: clamp(11px, 2.7vw, 13px);\">R$ 198,00</p><p class=\"font-extrabold leading-tight mt-0.5 text-orange-600\" style=\"font-size: clamp(18px, 4.8vw, 26px); line-height: 1.1; color: rgb(226, 85, 42);\">R$ 89,99</p><p class=\"text-gray-400 leading-none mt-0.5\" style=\"font-size: clamp(10px, 2.5vw, 12px);\">12x de R$ 10,14</p></div></div></div></label></div><div><label class=\"relative block rounded-2xl border-2 cursor-pointer transition-all duration-200 select-none overflow-hidden border-orange-500 shadow-md\" data-df-offer-quantity=\"1\" for=\"bundle-1\"><input checked=\"\" class=\"sr-only\" id=\"bundle-1\" name=\"bundle\" type=\"radio\" value=\"1\"/><div class=\"px-3 py-3 sm:px-5 sm:py-5 bg-white\"><div class=\"flex items-center gap-3 sm:gap-5\"><div class=\"flex-shrink-0 w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors border-orange-500 bg-orange-500\"><div class=\"w-2 h-2 rounded-full bg-white\"></div></div><div class=\"flex-1 min-w-0\"><div class=\"flex items-center gap-2 flex-wrap\"><span class=\"font-bold leading-tight text-gray-900\" style=\"font-size: clamp(14px, 3.5vw, 17px); max-width: 100%;\">Somente 1 pote</span><span class=\"border border-green-600 bg-green-50 text-green-700 font-bold rounded-full px-2 py-0.5 whitespace-nowrap flex-shrink-0\" style=\"font-size: clamp(10px, 2.4vw, 13px);\">-50% OFF</span></div><p class=\"text-gray-500 mt-0.5\" style=\"font-size: clamp(11px, 2.7vw, 13px);\">Rotina inicial · 1 pote • 30 dias de uso</p><p class=\"text-gray-500 mt-0.5\" data-df-unit-cost=\"true\" style=\"font-size:12px\">R$ 1,67/dia</p></div><div class=\"flex-shrink-0 text-right\"><p class=\"text-gray-400 line-through leading-none\" style=\"font-size: clamp(11px, 2.7vw, 13px);\">R$ 99,00</p><p class=\"font-extrabold leading-tight mt-0.5 text-orange-600\" style=\"font-size: clamp(18px, 4.8vw, 26px); line-height: 1.1; color: rgb(226, 85, 42);\">R$ 49,99</p><p class=\"text-gray-400 leading-none mt-0.5\" style=\"font-size: clamp(10px, 2.5vw, 12px);\">12x de R$ 5,41</p></div></div><div class=\"border-t border-gray-200 my-3\"></div><ul class=\"space-y-1.5\"><li class=\"flex items-center gap-2\" style=\"font-size: clamp(11px, 2.7vw, 13px);\"><svg aria-hidden=\"true\" class=\"lucide lucide-check w-3.5 h-3.5 text-green-600 flex-shrink-0\" fill=\"none\" height=\"24\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" viewbox=\"0 0 24 24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20 6 9 17l-5-5\"></path></svg><span class=\"text-gray-600\">Garantia de reembolso em 30 dias</span></li></ul></div></label></div></div><a class=\"w-full bg-gradient-to-r from-orange-500 to-orange-600 active:scale-[0.98] text-white font-bold px-6 rounded-full flex items-center justify-center gap-2 transition-transform shadow-lg text-[17px] sm:text-lg min-h-[54px] sm:min-h-[56px] touch-manipulation will-change-transform no-underline\" data-df-buy=\"\" data-df-selected-quantity=\"1\" href=\"#\" rel=\"noopener noreferrer\" style=\"-webkit-tap-highlight-color: transparent;\"><svg aria-hidden=\"true\" class=\"lucide lucide-shopping-bag w-5 h-5\" fill=\"none\" height=\"24\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" viewbox=\"0 0 24 24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16 10a4 4 0 0 1-8 0\"></path><path d=\"M3.103 6.034h17.794\"></path><path d=\"M3.4 5.467a2 2 0 0 0-.4 1.2V20a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6.667a2 2 0 0 0-.4-1.2l-2-2.667A2 2 0 0 0 17 2H7a2 2 0 0 0-1.6.8z\"></path></svg><span>Comprar Agora</span></a></div>", "2": "<div class=\"space-y-3\" id=\"hero-purchase\"><div class=\"space-y-3\"><div><label class=\"relative block rounded-2xl border-2 cursor-pointer transition-all duration-200 select-none overflow-hidden border-gray-200 hover:border-orange-300 hover:shadow-sm\" data-df-offer-quantity=\"3\" for=\"bundle-3\"><input class=\"sr-only\" id=\"bundle-3\" name=\"bundle\" type=\"radio\" value=\"3\"/><div class=\"w-full text-white text-center font-bold flex items-center justify-center gap-1.5\" style=\"background-color: rgb(249, 115, 22); padding: 5px 8px; font-size: clamp(11px, 2.7vw, 13px);\"><svg aria-hidden=\"true\" class=\"lucide lucide-gift w-3.5 h-3.5 flex-shrink-0\" fill=\"none\" height=\"24\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" viewbox=\"0 0 24 24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12 7v14\"></path><path d=\"M20 11v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-8\"></path><path d=\"M7.5 7a1 1 0 0 1 0-5A4.8 8 0 0 1 12 7a4.8 8 0 0 1 4.5-5 1 1 0 0 1 0 5\"></path><rect height=\"4\" rx=\"1\" width=\"18\" x=\"3\" y=\"7\"></rect></svg><span class=\"whitespace-nowrap\">Oferta exclusiva de hoje</span><span class=\"whitespace-nowrap flex items-center gap-1\"><svg aria-hidden=\"true\" class=\"lucide lucide-clock w-3 h-3 flex-shrink-0\" fill=\"none\" height=\"24\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" viewbox=\"0 0 24 24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"12\" cy=\"12\" r=\"10\"></circle><path d=\"M12 6v6l4 2\"></path></svg>02:38:06</span></div><div class=\"px-3 py-3 sm:px-5 sm:py-5 bg-white\"><div class=\"flex items-center gap-3 sm:gap-5\"><div class=\"flex-shrink-0 w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors border-gray-300 bg-white\"></div><div class=\"flex-1 min-w-0\"><div class=\"flex items-center gap-2 flex-wrap\"><span class=\"font-bold leading-tight text-gray-900\" style=\"font-size: clamp(14px, 3.5vw, 17px); max-width: 100%;\">3 potes + e-book grátis</span><span class=\"border border-green-600 bg-green-50 text-green-700 font-bold rounded-full px-2 py-0.5 whitespace-nowrap flex-shrink-0\" style=\"font-size: clamp(10px, 2.4vw, 13px);\">-60% OFF</span></div><p class=\"text-gray-500 mt-0.5\" style=\"font-size: clamp(11px, 2.7vw, 13px);\">Melhor resultado com 3 potes</p><p class=\"text-gray-500 mt-0.5\" style=\"font-size: clamp(10px, 2.5vw, 12px);\">R$ 1,33/dia</p></div><div class=\"flex-shrink-0 text-right\"><p class=\"text-gray-400 line-through leading-none\" style=\"font-size: clamp(11px, 2.7vw, 13px);\">R$ 297,00</p><p class=\"font-extrabold leading-tight mt-0.5 text-orange-600\" style=\"font-size: clamp(18px, 4.8vw, 26px); line-height: 1.1;\">R$ 119,99</p><p class=\"text-gray-400 leading-none mt-0.5\" style=\"font-size: clamp(10px, 2.5vw, 12px);\">12x de R$ 14,06</p></div></div></div></label></div><div><label class=\"relative block rounded-2xl border-2 cursor-pointer transition-all duration-200 select-none overflow-hidden border-orange-500 shadow-md\" data-df-offer-quantity=\"2\" for=\"bundle-2\"><input checked=\"\" class=\"sr-only\" id=\"bundle-2\" name=\"bundle\" type=\"radio\" value=\"2\"/><div class=\"px-3 py-3 sm:px-5 sm:py-5 bg-white\"><div class=\"flex items-center gap-3 sm:gap-5\"><div class=\"flex-shrink-0 w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors border-orange-500 bg-orange-500\"><div class=\"w-2 h-2 rounded-full bg-white\"></div></div><div class=\"flex-1 min-w-0\"><div class=\"flex items-center gap-2 flex-wrap\"><span class=\"font-bold leading-tight text-gray-900\" style=\"font-size: clamp(14px, 3.5vw, 17px); max-width: 100%;\">Somente 2 potes</span><span class=\"border border-green-600 bg-green-50 text-green-700 font-bold rounded-full px-2 py-0.5 whitespace-nowrap flex-shrink-0\" style=\"font-size: clamp(10px, 2.4vw, 13px);\">-55% OFF</span></div><p class=\"text-gray-500 mt-0.5\" style=\"font-size: clamp(11px, 2.7vw, 13px);\">Rotina inicial · 2 potes • 60 dias de uso</p><p class=\"text-gray-500 mt-0.5\" data-df-unit-cost=\"true\" style=\"font-size:12px\">R$ 1,50/dia</p></div><div class=\"flex-shrink-0 text-right\"><p class=\"text-gray-400 line-through leading-none\" style=\"font-size: clamp(11px, 2.7vw, 13px);\">R$ 198,00</p><p class=\"font-extrabold leading-tight mt-0.5 text-orange-600\" style=\"font-size: clamp(18px, 4.8vw, 26px); line-height: 1.1; color: rgb(226, 85, 42);\">R$ 89,99</p><p class=\"text-gray-400 leading-none mt-0.5\" style=\"font-size: clamp(10px, 2.5vw, 12px);\">12x de R$ 10,14</p></div></div><div class=\"border-t border-gray-200 my-3\"></div><ul class=\"space-y-1.5\"><li class=\"flex items-center gap-2\" style=\"font-size: clamp(11px, 2.7vw, 13px);\"><svg aria-hidden=\"true\" class=\"lucide lucide-check w-3.5 h-3.5 text-green-600 flex-shrink-0\" fill=\"none\" height=\"24\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" viewbox=\"0 0 24 24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20 6 9 17l-5-5\"></path></svg><span class=\"text-gray-600\">Garantia de reembolso em 30 dias</span></li></ul></div></label></div><div><label class=\"relative block rounded-2xl border-2 cursor-pointer transition-all duration-200 select-none overflow-hidden border-gray-200 hover:border-orange-300 hover:shadow-sm\" data-df-offer-quantity=\"1\" for=\"bundle-1\"><input class=\"sr-only\" id=\"bundle-1\" name=\"bundle\" type=\"radio\" value=\"1\"/><div class=\"px-3 py-3 sm:px-5 sm:py-5 bg-white\"><div class=\"flex items-center gap-3 sm:gap-5\"><div class=\"flex-shrink-0 w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors border-gray-300 bg-white\"></div><div class=\"flex-1 min-w-0\"><div class=\"flex items-center gap-2 flex-wrap\"><span class=\"font-bold leading-tight text-gray-900\" style=\"font-size: clamp(14px, 3.5vw, 17px); max-width: 100%;\">Somente 1 pote</span><span class=\"border border-green-600 bg-green-50 text-green-700 font-bold rounded-full px-2 py-0.5 whitespace-nowrap flex-shrink-0\" style=\"font-size: clamp(10px, 2.4vw, 13px);\">-50% OFF</span></div><p class=\"text-gray-500 mt-0.5\" style=\"font-size: clamp(11px, 2.7vw, 13px);\">Rotina inicial · 1 pote • 30 dias de uso</p></div><div class=\"flex-shrink-0 text-right\"><p class=\"text-gray-400 line-through leading-none\" style=\"font-size: clamp(11px, 2.7vw, 13px);\">R$ 99,00</p><p class=\"font-extrabold leading-tight mt-0.5 text-orange-600\" style=\"font-size: clamp(18px, 4.8vw, 26px); line-height: 1.1; color: rgb(226, 85, 42);\">R$ 49,99</p><p class=\"text-gray-400 leading-none mt-0.5\" style=\"font-size: clamp(10px, 2.5vw, 12px);\">12x de R$ 5,41</p></div></div></div></label></div></div><a class=\"w-full bg-gradient-to-r from-orange-500 to-orange-600 active:scale-[0.98] text-white font-bold px-6 rounded-full flex items-center justify-center gap-2 transition-transform shadow-lg text-[17px] sm:text-lg min-h-[54px] sm:min-h-[56px] touch-manipulation will-change-transform no-underline\" data-df-buy=\"\" data-df-selected-quantity=\"2\" href=\"#\" rel=\"noopener noreferrer\" style=\"-webkit-tap-highlight-color: transparent;\"><svg aria-hidden=\"true\" class=\"lucide lucide-shopping-bag w-5 h-5\" fill=\"none\" height=\"24\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" viewbox=\"0 0 24 24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16 10a4 4 0 0 1-8 0\"></path><path d=\"M3.103 6.034h17.794\"></path><path d=\"M3.4 5.467a2 2 0 0 0-.4 1.2V20a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6.667a2 2 0 0 0-.4-1.2l-2-2.667A2 2 0 0 0 17 2H7a2 2 0 0 0-1.6.8z\"></path></svg><span>Comprar Agora</span></a></div>", "3": "<div class=\"space-y-3\" id=\"hero-purchase\"><div class=\"space-y-3\"><div><label class=\"relative block rounded-2xl border-2 cursor-pointer transition-all duration-200 select-none overflow-hidden border-orange-500 shadow-md\" data-df-offer-quantity=\"3\" for=\"bundle-3\"><input checked=\"\" class=\"sr-only\" id=\"bundle-3\" name=\"bundle\" type=\"radio\" value=\"3\"/><div class=\"w-full text-white text-center font-bold flex items-center justify-center gap-1.5\" style=\"background-color: rgb(249, 115, 22); padding: 5px 8px; font-size: clamp(11px, 2.7vw, 13px);\"><svg aria-hidden=\"true\" class=\"lucide lucide-gift w-3.5 h-3.5 flex-shrink-0\" fill=\"none\" height=\"24\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" viewbox=\"0 0 24 24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12 7v14\"></path><path d=\"M20 11v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-8\"></path><path d=\"M7.5 7a1 1 0 0 1 0-5A4.8 8 0 0 1 12 7a4.8 8 0 0 1 4.5-5 1 1 0 0 1 0 5\"></path><rect height=\"4\" rx=\"1\" width=\"18\" x=\"3\" y=\"7\"></rect></svg><span class=\"whitespace-nowrap\">Oferta exclusiva de hoje</span><span class=\"whitespace-nowrap flex items-center gap-1\"><svg aria-hidden=\"true\" class=\"lucide lucide-clock w-3 h-3 flex-shrink-0\" fill=\"none\" height=\"24\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" viewbox=\"0 0 24 24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"12\" cy=\"12\" r=\"10\"></circle><path d=\"M12 6v6l4 2\"></path></svg>02:36:00</span></div><div class=\"px-3 py-3 sm:px-5 sm:py-5 bg-white\"><div class=\"flex items-center gap-3 sm:gap-5\"><div class=\"flex-shrink-0 w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors border-orange-500 bg-orange-500\"><div class=\"w-2 h-2 rounded-full bg-white\"></div></div><div class=\"flex-1 min-w-0\"><div class=\"flex items-center gap-2 flex-wrap\"><span class=\"font-bold leading-tight text-gray-900\" style=\"font-size: clamp(14px, 3.5vw, 17px); max-width: 100%;\">3 potes + e-book grátis</span><span class=\"border border-green-600 bg-green-50 text-green-700 font-bold rounded-full px-2 py-0.5 whitespace-nowrap flex-shrink-0\" style=\"font-size: clamp(10px, 2.4vw, 13px);\">-60% OFF</span></div><p class=\"text-gray-500 mt-0.5\" style=\"font-size: clamp(11px, 2.7vw, 13px);\">Melhor resultado com 3 potes</p><p class=\"text-gray-500 mt-0.5\" style=\"font-size: clamp(10px, 2.5vw, 12px);\">R$ 1,33/dia</p></div><div class=\"flex-shrink-0 text-right\"><p class=\"text-gray-400 line-through leading-none\" style=\"font-size: clamp(11px, 2.7vw, 13px);\">R$ 297,00</p><p class=\"font-extrabold leading-tight mt-0.5 text-orange-600\" style=\"font-size: clamp(18px, 4.8vw, 26px); line-height: 1.1;\">R$ 119,99</p><p class=\"text-gray-400 leading-none mt-0.5\" style=\"font-size: clamp(10px, 2.5vw, 12px);\">12x de R$ 14,06</p></div></div><div class=\"border-t border-gray-200 my-3\"></div><p class=\"text-gray-900 font-bold mb-2\" style=\"font-size: clamp(11px, 2.7vw, 13px);\">Comprando 3 potes, você leva grátis:</p><div class=\"flex items-center gap-2 mb-3\"><div class=\"relative w-10 h-10 flex-shrink-0 rounded-lg border border-gray-300 bg-[#FFFDF7]\"><div class=\"absolute -top-2 -left-1 bg-green-100 border border-green-700 text-green-800 font-bold rounded-full px-1.5 py-0.5 whitespace-nowrap z-10 shadow-sm leading-none\" style=\"font-size: clamp(6px, 1.5vw, 8px);\">Grátis</div><img alt=\"Protocolo 7 Dias\" class=\"w-full h-full object-cover rounded-lg\" height=\"1080\" loading=\"eager\" src=\"https://cdn.shopify.com/s/files/1/0838/5347/6113/files/Capa_Oferta_Ebook.webp?v=1789769016\" width=\"1080\"/></div><span class=\"font-semibold text-gray-800\" style=\"font-size: clamp(11px, 2.7vw, 13px);\">Protocolo 7 Dias</span></div><div class=\"border-t border-gray-200 my-3\"></div><ul class=\"space-y-1.5\"><li class=\"flex items-center gap-2\" style=\"font-size: clamp(11px, 2.7vw, 13px);\"><svg aria-hidden=\"true\" class=\"lucide lucide-check w-3.5 h-3.5 text-green-600 flex-shrink-0\" fill=\"none\" height=\"24\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" viewbox=\"0 0 24 24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20 6 9 17l-5-5\"></path></svg><span class=\"text-gray-600\">Garantia de reembolso em 30 dias</span></li></ul></div></label></div><div><label class=\"relative block rounded-2xl border-2 cursor-pointer transition-all duration-200 select-none overflow-hidden border-gray-200 hover:border-orange-300 hover:shadow-sm\" data-df-offer-quantity=\"2\" for=\"bundle-2\"><input class=\"sr-only\" id=\"bundle-2\" name=\"bundle\" type=\"radio\" value=\"2\"/><div class=\"px-3 py-3 sm:px-5 sm:py-5 bg-white\"><div class=\"flex items-center gap-3 sm:gap-5\"><div class=\"flex-shrink-0 w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors border-gray-300 bg-white\"></div><div class=\"flex-1 min-w-0\"><div class=\"flex items-center gap-2 flex-wrap\"><span class=\"font-bold leading-tight text-gray-900\" style=\"font-size: clamp(14px, 3.5vw, 17px); max-width: 100%;\">Somente 2 potes</span><span class=\"border border-green-600 bg-green-50 text-green-700 font-bold rounded-full px-2 py-0.5 whitespace-nowrap flex-shrink-0\" style=\"font-size: clamp(10px, 2.4vw, 13px);\">-55% OFF</span></div><p class=\"text-gray-500 mt-0.5\" style=\"font-size: clamp(11px, 2.7vw, 13px);\">Rotina inicial · 2 potes • 60 dias de uso</p></div><div class=\"flex-shrink-0 text-right\"><p class=\"text-gray-400 line-through leading-none\" style=\"font-size: clamp(11px, 2.7vw, 13px);\">R$ 198,00</p><p class=\"font-extrabold leading-tight mt-0.5 text-orange-600\" style=\"font-size: clamp(18px, 4.8vw, 26px); line-height: 1.1; color: rgb(226, 85, 42);\">R$ 89,99</p><p class=\"text-gray-400 leading-none mt-0.5\" style=\"font-size: clamp(10px, 2.5vw, 12px);\">12x de R$ 10,14</p></div></div></div></label></div><div><label class=\"relative block rounded-2xl border-2 cursor-pointer transition-all duration-200 select-none overflow-hidden border-gray-200 hover:border-orange-300 hover:shadow-sm\" data-df-offer-quantity=\"1\" for=\"bundle-1\"><input class=\"sr-only\" id=\"bundle-1\" name=\"bundle\" type=\"radio\" value=\"1\"/><div class=\"px-3 py-3 sm:px-5 sm:py-5 bg-white\"><div class=\"flex items-center gap-3 sm:gap-5\"><div class=\"flex-shrink-0 w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors border-gray-300 bg-white\"></div><div class=\"flex-1 min-w-0\"><div class=\"flex items-center gap-2 flex-wrap\"><span class=\"font-bold leading-tight text-gray-900\" style=\"font-size: clamp(14px, 3.5vw, 17px); max-width: 100%;\">Somente 1 pote</span><span class=\"border border-green-600 bg-green-50 text-green-700 font-bold rounded-full px-2 py-0.5 whitespace-nowrap flex-shrink-0\" style=\"font-size: clamp(10px, 2.4vw, 13px);\">-50% OFF</span></div><p class=\"text-gray-500 mt-0.5\" style=\"font-size: clamp(11px, 2.7vw, 13px);\">Rotina inicial · 1 pote • 30 dias de uso</p></div><div class=\"flex-shrink-0 text-right\"><p class=\"text-gray-400 line-through leading-none\" style=\"font-size: clamp(11px, 2.7vw, 13px);\">R$ 99,00</p><p class=\"font-extrabold leading-tight mt-0.5 text-orange-600\" style=\"font-size: clamp(18px, 4.8vw, 26px); line-height: 1.1; color: rgb(226, 85, 42);\">R$ 49,99</p><p class=\"text-gray-400 leading-none mt-0.5\" style=\"font-size: clamp(10px, 2.5vw, 12px);\">12x de R$ 5,41</p></div></div></div></label></div></div><a class=\"w-full bg-gradient-to-r from-orange-500 to-orange-600 active:scale-[0.98] text-white font-bold px-6 rounded-full flex items-center justify-center gap-2 transition-transform shadow-lg text-[17px] sm:text-lg min-h-[54px] sm:min-h-[56px] touch-manipulation will-change-transform no-underline\" data-df-buy=\"\" data-df-selected-quantity=\"3\" href=\"#\" rel=\"noopener noreferrer\" style=\"-webkit-tap-highlight-color: transparent;\"><svg aria-hidden=\"true\" class=\"lucide lucide-shopping-bag w-5 h-5\" fill=\"none\" height=\"24\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" viewbox=\"0 0 24 24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16 10a4 4 0 0 1-8 0\"></path><path d=\"M3.103 6.034h17.794\"></path><path d=\"M3.4 5.467a2 2 0 0 0-.4 1.2V20a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6.667a2 2 0 0 0-.4-1.2l-2-2.667A2 2 0 0 0 17 2H7a2 2 0 0 0-1.6.8z\"></path></svg><span>Comprar Agora</span></a></div>"};
  const ensureDermafixOffers = () => {
    for (const [qty, markup] of Object.entries(DERMAFIX_OFFERS)) {
      let template=document.querySelector('#df-offer-'+qty);
      if (!template) { template=document.createElement('template'); template.id='df-offer-'+qty; root.append(template); }
      template.innerHTML=markup;
    }
    const purchase=root.querySelector('#hero-purchase');
    if (purchase && !purchase.querySelector('[data-df-offer-quantity="2"]')) {
      const selected=purchase.querySelector('input:checked')?.value || '3';
      purchase.outerHTML=DERMAFIX_OFFERS[selected] || DERMAFIX_OFFERS['3'];
    }
  };
  const replaceMockOfferPrices = () => {
    const purchase=getRoot()?.querySelector('#hero-purchase');
    if (!purchase) return;
    if (!purchase.querySelector('[data-df-price-freight-note]')) {
      const p=document.createElement('p'); p.dataset.dfPriceFreightNote='true';
      p.textContent='Frete calculado no checkout.';
      p.style.cssText='text-align:center;font-size:12px;color:#6b7280;margin-top:8px;'; purchase.append(p);
    }
    const quantity=Number(purchase.querySelector('input:checked')?.value || 3);
    const price={1:'49,99',2:'89,99',3:'119,99'}[quantity];
    root.querySelectorAll('[data-df-sticky] p').forEach(p=>{const text='R$ '+price;if(p.textContent!==text)p.textContent=text;});
  };

  const replaceMockProductWeight = () => {
    const currentRoot = getRoot();
    if (!currentRoot) return;
    const walker = document.createTreeWalker(currentRoot, NodeFilter.SHOW_TEXT);
    const nodes = [];
    let node;
    while ((node = walker.nextNode())) nodes.push(node);
    nodes.forEach((textNode) => {
      const nextValue = textNode.nodeValue.replace(/\b200g\b/gi, '100g');
      if (nextValue !== textNode.nodeValue) textNode.nodeValue = nextValue;
    });
  };

  const normaliseText = (value) => String(value || '').replace(/\s+/g, ' ').trim();

  const createHeroBenefit = (label) => {
    const item = document.createElement('li');
    item.className = 'df-hero-benefit';
    const icon = document.createElement('span');
    icon.className = 'df-hero-benefit__icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = '✓';
    const text = document.createElement('span');
    text.textContent = label;
    item.append(icon, text);
    return item;
  };

  const ensureHeroCopy = () => {
    const hero = root.querySelector('#hero-section');
    const titles = hero ? Array.from(hero.querySelectorAll('h1')) : [];
    if (!hero || !titles.length) return;

    titles.forEach((title) => {
      title.classList.add('df-hero-title');
      title.innerHTML = 'O creme número 1 para combater <span class="df-hero-title__accent">celulite, flacidez, lipedema e estrias</span>';

      let eyebrow = title.parentElement?.querySelector('[data-df-hero-eyebrow]');
      if (!eyebrow) {
        eyebrow = document.createElement('p');
        eyebrow.dataset.dfHeroEyebrow = 'true';
        eyebrow.className = 'df-hero-eyebrow';
        title.insertAdjacentElement('beforebegin', eyebrow);
      }
      eyebrow.textContent = 'Dermafix – Textura, Firmeza e Hidratação';
    });

    const benefitsHeading = Array.from(hero.querySelectorAll('h3')).find((element) => /Por que ele é o mais procurado/i.test(element.textContent || ''));
    const benefitsList = benefitsHeading?.parentElement?.querySelector('ul');
    if (benefitsHeading && benefitsList) {
      benefitsHeading.textContent = 'Principais benefícios do Dermafix';
      benefitsList.classList.add('df-hero-benefits');
      benefitsList.dataset.dfHeroBenefits = 'true';
      benefitsList.replaceChildren(
        createHeroBenefit('Auxilia no combate à celulite'),
        createHeroBenefit('Auxilia no combate às estrias'),
        createHeroBenefit('Auxilia no desconforto e inchaço do lipedema')
      );
    }

    const tagline = Array.from(hero.querySelectorAll('p')).find((element) => /N[aã]o é creme comum\. É tratamento/i.test(element.textContent || ''));
    if (tagline) {
      tagline.dataset.dfHeroSubtitle = 'true';
      tagline.textContent = 'Cuidado diário com ativos de alta performance.';
    }
  };

  const rewriteInvestmentCallout = () => {
    const currentRoot = getRoot();
    const existingOffer = currentRoot?.querySelector('section[data-df-investment-offer="true"]');
    if (existingOffer) {
      const reviews = currentRoot.querySelector('#df-reviews');
      const reviewHost = reviews?.parentElement?.children.length === 1 ? reviews.parentElement : reviews;
      const investmentHost = existingOffer.parentElement?.children.length === 1 ? existingOffer.parentElement : existingOffer;
      const target = reviewHost?.parentElement;
      if (reviewHost && investmentHost && target && target === investmentHost.parentElement
        && reviewHost.compareDocumentPosition(investmentHost) & Node.DOCUMENT_POSITION_FOLLOWING) {
        target.insertBefore(investmentHost, reviewHost);
      }
      return;
    }
    const section = Array.from(currentRoot?.querySelectorAll('section') || []).find((candidate) => /N[aã]o [eé] custo\. [EÉ] investimento em voc[eê]/i.test(normaliseText(candidate.textContent)));
    if (!section) return;

    const investmentMedia = {
      src: 'https://cdn.shopify.com/s/files/1/0838/5347/6113/files/Imagem2_695425f6-9c0f-40dc-8363-bd480b047f59.webp?v=1788566629',
      alt: 'Dermafix 100g em uso'
    };
    if (section.dataset.dfInvestmentOffer !== 'true') {
      section.replaceChildren();
      const inner = document.createElement('div');
      inner.className = 'df-investment-offer';
      inner.innerHTML = `
        <div class="df-investment-offer__media">
          <img data-df-investment-media="true" alt="Dermafix 100g" loading="lazy" decoding="async">
        </div>
        <div class="df-investment-offer__content">
          <p class="df-investment-offer__eyebrow">CUIDADO CORPORAL COREANO</p>
          <h2>SEU CUIDADO CORPORAL COMEÇA AQUI</h2>
          <p class="df-investment-offer__copy">Uma rotina simples para cuidar da aparência da celulite, da flacidez e das estrias com ativos de alta performance.</p>
          <a class="df-section-cta" data-df-section-cta="true" href="#hero-purchase">ADICIONAR AO CARRINHO</a>
          <span class="df-investment-offer__urgency">OFERTA ESPECIAL POR TEMPO LIMITADO</span>
        </div>`;
      section.append(inner);
      section.dataset.dfInvestmentOffer = 'true';
    }
    const image = section.querySelector('[data-df-investment-media="true"]');
    if (image && investmentMedia.src && image.src !== investmentMedia.src) {
      image.src = investmentMedia.src;
      image.alt = investmentMedia.alt;
    }
    section.dataset.dfInvestmentCopy = 'true';

    const reviews = currentRoot.querySelector('#df-reviews');
    const reviewHost = reviews?.parentElement?.children.length === 1 ? reviews.parentElement : reviews;
    const investmentHost = section.parentElement?.children.length === 1 ? section.parentElement : section;
    const target = reviewHost?.parentElement;
    if (reviewHost && investmentHost && target && target === investmentHost.parentElement
      && reviewHost.compareDocumentPosition(investmentHost) & Node.DOCUMENT_POSITION_FOLLOWING) {
      target.insertBefore(investmentHost, reviewHost);
    }
  };

  const ensureKoreanSeal = () => {
    const currentRoot = getRoot();
    const accordion = Array.from(currentRoot?.querySelectorAll('[data-df-accordion="description"]') || [])
      .find((button) => /Descri.{0,5}o do produto/i.test(normaliseText(button.textContent)));
    const panel = accordion?.nextElementSibling;
    if (!panel) return;

    let seal = panel.querySelector('[data-df-korean-origin="true"]');
    if (!seal) {
      seal = document.createElement('div');
      seal.dataset.dfKoreanOrigin = 'true';
      seal.className = 'df-korean-origin';
      seal.innerHTML = `
        <img src="https://cdn.shopify.com/s/files/1/0838/5347/6113/files/korean_selo.webp?v=1789874976" alt="Selo de origem coreana" width="82" height="82" loading="lazy" decoding="async">
        <span class="df-korean-origin__copy"><strong>Dermafix de origem coreana</strong><small>Korean Beauty para o seu cuidado corporal</small></span>`;
      panel.prepend(seal);
    }
  };

  const hidePostPurchaseProof = () => {
    const currentRoot = getRoot();
    if (!currentRoot) return;

    const refundCopy = Array.from(currentRoot.querySelectorAll('strong'))
      .find((element) => /^Menos de 1%/i.test(normaliseText(element.parentElement?.textContent)));
    const refundBox = refundCopy?.closest('.rounded-xl') || refundCopy?.parentElement;
    if (refundBox) {
      refundBox.hidden = true;
      refundBox.setAttribute('aria-hidden', 'true');
      refundBox.dataset.dfHiddenProof = 'true';
    }

    const recentSales = Array.from(currentRoot.querySelectorAll('span'))
      .find((element) => /1\s+VENDIDO\s+A\s+CADA\s+40\s+SEGUNDOS/i.test(normaliseText(element.textContent)));
    const recentSalesBlock = recentSales?.closest('.text-center');
    if (recentSalesBlock) {
      recentSalesBlock.hidden = true;
      recentSalesBlock.setAttribute('aria-hidden', 'true');
      recentSalesBlock.dataset.dfHiddenProof = 'true';
    }
  };

  const ensureShippingPriorityIcon = () => {
    const currentRoot = getRoot();
    const label = Array.from(currentRoot?.querySelectorAll('p') || [])
      .find((element) => normaliseText(element.textContent) === 'Prioridade m\u00e1xima no envio');
    const iconHost = label?.parentElement?.parentElement?.firstElementChild;
    if (!iconHost || iconHost.dataset.dfTruckIcon === 'true') return;
    iconHost.dataset.dfTruckIcon = 'true';
    iconHost.innerHTML = `<svg class="df-truck-icon" aria-hidden="true" fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M3 5h10a2 2 0 0 1 2 2v9H3a1 1 0 0 1-1-1V7a2 2 0 0 1 2-2Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"/><path d="M15 9h3.2a2 2 0 0 1 1.6.8L22 13v3h-7V9Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"/><circle cx="6.5" cy="17" r="2" stroke="currentColor" stroke-width="1.8"/><circle cx="18.5" cy="17" r="2" stroke="currentColor" stroke-width="1.8"/></svg>`;
  };

  const ensureReviewsBeforeAssets = () => {
    const currentRoot = getRoot();
    if (!currentRoot) return;
    const reviews = currentRoot.querySelector('#df-reviews');
    const assets = Array.from(currentRoot.querySelectorAll('section')).find((candidate) => /Diferenciais e Ativos/i.test(normaliseText(candidate.textContent)));
    if (!reviews || !assets) return;

    const reviewHost = reviews.parentElement?.children.length === 1 ? reviews.parentElement : reviews;
    const assetHost = assets.parentElement?.children.length === 1 ? assets.parentElement : assets;
    const target = assetHost.parentElement;
    if (!reviewHost || !assetHost || !target || target !== reviewHost.parentElement) return;
    if (assetHost.compareDocumentPosition(reviewHost) & Node.DOCUMENT_POSITION_FOLLOWING) {
      target.insertBefore(reviewHost, assetHost);
    }
    reviewHost.dataset.dfReviewsMoved = 'true';
  };

  const ensureAssetsFeature = () => {
    const currentRoot = getRoot();
    const section = Array.from(currentRoot?.querySelectorAll('section') || [])
      .find((candidate) => candidate.dataset.dfIngredientFeature !== 'true'
        && /Diferenciais e Ativos/i.test(normaliseText(candidate.textContent)));
    if (!section) return;

    const formulaSection = Array.from(currentRoot.querySelectorAll('section'))
      .find((candidate) => candidate !== section
        && candidate.dataset.dfAssetsFeature !== 'true'
        && /F[ÓO]RMULA SUPERIOR/i.test(normaliseText(candidate.textContent)));

    if (section.dataset.dfAssetsFeature !== 'true') {
      const ingredientClone = section.cloneNode(true);
      ingredientClone.dataset.dfIngredientFeature = 'true';
      ingredientClone.dataset.dfSurface = 'white';
      section.parentElement?.insertBefore(ingredientClone, section);
      section.replaceChildren();
      const inner = document.createElement('div');
      inner.className = 'df-assets-feature';
      inner.innerHTML = `
        <div class="df-assets-feature__intro">
          <h2>Por que o Dermafix é o mais escolhido?</h2>
          <p class="df-assets-feature__subheadline">Porque entrega mais resultado.</p>
          <p class="df-assets-feature__intro-copy">Produtos comuns usam fórmulas básicas com baixa concentração de ativos. Nós investimos em ciência e qualidade para você ter resultados reais.</p>
        </div>
        <div class="df-assets-feature__layout">
          <div class="df-assets-feature__formula">
            <div class="df-assets-feature__formula-stage">
              <p class="df-assets-feature__formula-kicker">ATIVOS EM SINERGIA</p>
              <svg class="df-assets-feature__formula-art" aria-hidden="true" viewBox="0 0 560 360" xmlns="http://www.w3.org/2000/svg">
                <g fill="none" stroke="#111827" stroke-linecap="round" stroke-linejoin="round" stroke-width="3">
                  <path d="M108 188 170 151l62 36v72l-62 36-62-36z"/>
                  <path d="m108 188 62 36 62-37M170 295v-71"/>
                  <path d="M232 187 294 151l62 36v72l-62 36-62-36z"/>
                  <path d="m232 187 62 37 62-37M294 295v-71"/>
                  <path d="M356 187 418 151l62 36v72l-62 36-62-36z"/>
                  <path d="m356 187 62 37 62-37M418 295v-71"/>
                  <path d="M170 151v-55M294 151V96M418 151V96"/>
                  <path d="m170 96 16-24M294 96l16-24M418 96l16-24"/>
                  <path d="M232 223h-51M356 223h-51"/>
                </g>
                <g fill="#BE0121">
                  <circle cx="170" cy="96" r="7"/><circle cx="294" cy="96" r="7"/><circle cx="418" cy="96" r="7"/>
                  <circle cx="232" cy="223" r="7"/><circle cx="356" cy="223" r="7"/>
                </g>
                <g fill="#111827" font-family="sans-serif" font-size="17" font-weight="700">
                  <text x="80" y="335">NICOTINATO</text><text x="240" y="335">CAFEÍNA</text><text x="390" y="335">GENGIBRE</text>
                </g>
              </svg>
              <div class="df-assets-feature__formula-caption"><strong>Fórmula pensada para agir em conjunto</strong><span>Ativos selecionados para o cuidado corporal diário.</span></div>
            </div>
            <ul class="df-assets-feature__checks" aria-label="Diferenciais da fórmula">
              <li><span aria-hidden="true">✓</span><span>Ativos de alta performance</span></li>
              <li><span aria-hidden="true">✓</span><span>Cuidado corporal inspirado na beleza coreana</span></li>
              <li><span aria-hidden="true">✓</span><span>Textura pensada para a rotina diária</span></li>
            </ul>
          </div>
          <div class="df-assets-feature__copy">
            <p class="df-assets-feature__label">ATIVOS QUE TRABALHAM JUNTOS</p>
            <h3>Uma combinação de ativos que trabalha onde importa</h3>
            <p>O Dermafix combina concentração, absorção e tecnologia para cuidar da aparência da celulite, da flacidez e das estrias.</p>
            <div class="df-assets-feature__points" aria-label="Diferenciais da fórmula">
              <div><span class="df-assets-feature__point-number">01</span><span><strong>5x mais Nicotinato de Metila</strong><small>Enquanto produtos comuns têm 1%, o Dermafix possui 5% de concentração.</small></span></div>
              <div><span class="df-assets-feature__point-number">02</span><span><strong>Ativos farmacêuticos de alta performance</strong><small>Nicotinato de Metila, Cafeína, Gengibre, Pimenta Preta, Arnica e Mica em uma combinação exclusiva.</small></span></div>
              <div><span class="df-assets-feature__point-number">03</span><span><strong>Tecnologia de absorção profunda</strong><small>Não fica apenas na superfície: penetra até as camadas mais profundas da pele.</small></span></div>
              <div><span class="df-assets-feature__point-number">04</span><span><strong>Concentração de ativo 3x maior</strong><small>Entrega mais ativos por aplicação para potencializar o cuidado diário.</small></span></div>
            </div>
          </div>
        </div>
        <a class="df-section-cta" data-df-section-cta="true" href="#hero-purchase">ADICIONAR AO CARRINHO</a>`;
      section.append(inner);
      section.dataset.dfAssetsFeature = 'true';
    }
    section.querySelector('.df-assets-feature__eyebrow')?.remove();
    section.querySelector('.df-assets-feature__intro')?.remove();
    section.querySelector('.df-assets-feature__formula-kicker')?.remove();
    section.querySelector('.df-assets-feature__label')?.remove();
    section.dataset.dfSurface = 'soft';
    if (formulaSection && formulaSection !== section) {
      formulaSection.replaceWith(section);
      section.dataset.dfAssetsFeatureRelocated = 'true';
    }
  };

  let accordionScrollGuardBound = false;
  const ensureAccordionScrollGuard = () => {
    if (accordionScrollGuardBound) return;
    accordionScrollGuardBound = true;
    document.addEventListener('click', (event) => {
      const accordion = event.target.closest?.('[data-df-accordion="specs"]');
      if (!accordion) return;
      const startY = window.scrollY;
      accordion.blur();
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          if (Math.abs(window.scrollY - startY) < 2) return;
          window.scrollTo({ top: startY, behavior: 'smooth' });
        });
      });
    }, true);
  };

  const ensureIngredientCarousel = () => {
    const currentRoot = getRoot();
    const section = currentRoot?.querySelector('section[data-df-ingredient-feature="true"]');
    const scroller = section?.querySelector('.overflow-x-auto');
    if (!section || !scroller) return;

    scroller.dataset.dfIngredientScroller = 'true';
    Array.from(section.querySelectorAll('button')).forEach((button) => {
      if (button.dataset.dfIngredientControl === 'true') return;
      const previous = button.hidden || button.getAttribute('aria-label') === 'Ativos anteriores';
      button.dataset.dfIngredientControl = 'true';
      button.setAttribute('aria-label', previous ? 'Ativos anteriores' : 'Pr\u00f3ximos ativos');
      button.innerHTML = '<svg aria-hidden="true" fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="m9 18 6-6-6-6" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/></svg>';
      if (previous) button.querySelector('svg').style.transform = 'rotate(180deg)';
      button.addEventListener('click', () => {
        scroller.scrollBy({ left: previous ? -scroller.clientWidth * .8 : scroller.clientWidth * .8, behavior: 'smooth' });
      });
    });

    if (scroller.dataset.dfIngredientEvents === 'true') return;
    scroller.dataset.dfIngredientEvents = 'true';
    const updateControls = () => {
      const atStart = scroller.scrollLeft < 10;
      const atEnd = scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 10;
      section.querySelectorAll('button[data-df-ingredient-control="true"]').forEach((button) => {
        const previous = button.getAttribute('aria-label') === 'Ativos anteriores';
        button.hidden = previous ? atStart : atEnd;
      });
    };
    scroller.addEventListener('scroll', updateControls, { passive: true });
    updateControls();
  };

  const ensureHeroVisual = () => {
    root.querySelectorAll('[data-df-hero-visual-card="true"]').forEach((card) => card.remove());
  };

  const syncStickyProductMedia = () => {
    const stickyMedia = 'https://cdn.shopify.com/s/files/1/0838/5347/6113/files/1undermafixsite_1.png?v=1788566891';
    document.querySelectorAll('[data-df-sticky] img').forEach((image) => {
      if (image.src !== stickyMedia) image.src = stickyMedia;
      image.alt = 'Dermafix 100g';
    });
    document.querySelectorAll('[data-df-sticky] button').forEach((button) => {
      button.style.setProperty('background', '#BE0121', 'important');
      button.style.setProperty('background-image', 'none', 'important');
      button.style.setProperty('border', '4px solid #202020', 'important');
      button.style.setProperty('border-radius', '999px', 'important');
      button.style.setProperty('gap', '0', 'important');
      button.querySelectorAll('svg').forEach((icon) => icon.remove());
    });
  };

  const ensureStorePromoBar = () => {
    if (document.querySelector('[data-df-store-promo="true"]')) return;
    const currentRoot = getRoot();
    const main = document.querySelector('#MainContent');
    if (!currentRoot || !main) return;

    const section = currentRoot.closest('.shopify-section');
    const anchor = section?.parentElement === main ? section : currentRoot;
    if (!anchor?.parentElement) return;

    const bar = document.createElement('div');
    bar.dataset.dfStorePromo = 'true';
    bar.className = 'df-store-promo';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Oferta da Attracione');
    bar.innerHTML = '<div class="df-store-promo__text"><p>FRETE GRÁTIS* e 50% DE DESCONTO</p></div>';
    anchor.insertAdjacentElement('beforebegin', bar);
  };

  let stickyMediaObserverBound = false;
  const setupStickyProductMedia = () => {
    syncStickyProductMedia();
    if (stickyMediaObserverBound || !document.body) return;
    stickyMediaObserverBound = true;
    window.addEventListener('scroll', syncStickyProductMedia, { passive: true });
    const observer = new MutationObserver(syncStickyProductMedia);
    observer.observe(document.body, { childList: true, subtree: true });
  };

  const ensurePressBar = () => {
    const currentRoot = getRoot();
    const hero = currentRoot?.querySelector('#hero-section');
    if (!currentRoot || !hero || currentRoot.querySelector('[data-df-press-section="true"]')) return;

    const materials = [
      {
        alt: 'Logo Terra',
        src: 'https://cdn.shopify.com/s/files/1/0838/5347/6113/files/terra-logo-1_f1810b9c-6a59-4209-b837-ed79a9329a7f.webp?v=1793381448&width=1280'
      },
      {
        alt: 'Logo Folha de S.Paulo',
        src: 'https://cdn.shopify.com/s/files/1/0838/5347/6113/files/folha-de-s-paulo-1_57e80a27-8d2d-4023-a4b0-32519b926c35.webp?v=1793381447&width=1280'
      },
      {
        alt: 'Logo Metropoles',
        src: 'https://cdn.shopify.com/s/files/1/0838/5347/6113/files/metropoles-1_77e450c4-e5a6-435a-9104-8747ba9104d9.webp?v=1793381448&width=1280'
      },
      {
        alt: 'Logo SBT News',
        src: 'https://cdn.shopify.com/s/files/1/0838/5347/6113/files/sbticon-1.webp?v=1793381447&width=1280'
      }
    ];

    const section = document.createElement('section');
    section.dataset.dfPressSection = 'true';
    section.setAttribute('aria-labelledby', 'df-press-title');
    section.innerHTML = `<div class="df-press-inner"><h2 id="df-press-title" class="df-press-title">VISTO EM</h2><div class="df-press-logos">${materials.map((material) => `<img class="df-press-logo" src="${material.src}" alt="${material.alt}" width="200" height="55" loading="lazy" decoding="async">`).join('')}</div></div>`;
    hero.insertAdjacentElement('afterend', section);
  };

  const ensureSituationsGrid = () => {
    const currentRoot = getRoot();
    const section = Array.from(currentRoot?.querySelectorAll('section') || []).find((candidate) => /J[aá] pass(?:ou|aram) por alguma dessas situações/i.test(normaliseText(candidate.textContent)));
    if (!section) return;
    section.dataset.dfSituationsSection = 'true';
    section.dataset.dfSurface = 'white';

    const labels = [
      'Celulites no Bumbum',
      'Bolinhas de Foliculite',
      'Flacidez',
      'Estrias'
    ];

    const grid = Array.from(section.querySelectorAll('div')).find((candidate) => {
      const children = Array.from(candidate.children);
      return children.length === 4 && children.every((child) => child.querySelector('img'));
    });
    if (grid) {
      grid.dataset.dfSituationsGrid = 'true';
      Array.from(grid.children).forEach((card, index) => {
        card.dataset.dfSituationCard = String(index + 1);
        card.setAttribute('role', 'listitem');
        card.setAttribute('aria-label', labels[index]);
        const text = card.querySelector('p, h3, h4');
        if (text) text.textContent = labels[index];
      });
      grid.setAttribute('role', 'list');
      grid.id = grid.id || 'df-situations-grid';
      const carousel = grid.parentElement;
      if (carousel) {
        carousel.dataset.dfSituationsCarousel = 'true';
        const createArrow = (direction, label) => {
          const arrow = document.createElement('button');
          arrow.type = 'button';
          arrow.dataset[`dfSituations${direction === 'next' ? 'Next' : 'Previous'}`] = 'true';
          arrow.className = `df-situations-${direction}`;
          arrow.setAttribute('aria-label', label);
          arrow.setAttribute('aria-controls', grid.id);
          arrow.innerHTML = '<svg class="df-situations-arrow-icon" aria-hidden="true" fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="m9 18 6-6-6-6" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/></svg>';
          return arrow;
        };

        const nextArrow = carousel.querySelector('[data-df-situations-next="true"]')
          || createArrow('next', 'Ver a pr\u00f3xima situa\u00e7\u00e3o');
        const previousArrow = carousel.querySelector('[data-df-situations-previous="true"]')
          || createArrow('previous', 'Voltar para a situa\u00e7\u00e3o anterior');
        if (!nextArrow.parentElement) carousel.append(nextArrow);
        if (!previousArrow.parentElement) carousel.append(previousArrow);

        const targetFor = (card) => {
          if (!card) return 0;
          const gridRect = grid.getBoundingClientRect();
          const cardRect = card.getBoundingClientRect();
          return Math.max(0, grid.scrollLeft + cardRect.left - gridRect.left - 3);
        };

        const syncArrows = () => {
          const maxScroll = Math.max(0, grid.scrollWidth - grid.clientWidth);
          const atStart = grid.scrollLeft <= 8;
          const atEnd = maxScroll <= 8 || grid.scrollLeft >= maxScroll - 8;
          previousArrow.hidden = atStart;
          nextArrow.hidden = atEnd;
          previousArrow.setAttribute('aria-hidden', String(atStart));
          nextArrow.setAttribute('aria-hidden', String(atEnd));
        };

        const positionArrows = () => {
          const carouselRect = carousel.getBoundingClientRect();
          const gridRect = grid.getBoundingClientRect();
          const image = grid.querySelector('[data-df-situation-card="1"] img');
          const imageRect = image?.getBoundingClientRect();
          const buttonHeight = nextArrow.offsetHeight || previousArrow.offsetHeight || 44;
          const top = imageRect
            ? imageRect.top - carouselRect.top + Math.max(0, (imageRect.height - buttonHeight) / 2)
            : gridRect.top - carouselRect.top;
          nextArrow.style.setProperty('top', `${Math.max(0, top)}px`, 'important');
          previousArrow.style.setProperty('top', `${Math.max(0, top)}px`, 'important');
          previousArrow.style.setProperty('left', `${Math.max(4, gridRect.left - carouselRect.left)}px`, 'important');
          previousArrow.style.setProperty('right', 'auto', 'important');
          nextArrow.style.setProperty('right', `${Math.max(4, carouselRect.right - gridRect.right)}px`, 'important');
          nextArrow.style.setProperty('left', 'auto', 'important');
        };

        previousArrow.querySelector('svg').style.transform = 'rotate(180deg)';
        nextArrow.querySelector('svg').style.transform = '';
        if (grid.dataset.dfSituationsControls !== 'true') {
          grid.dataset.dfSituationsControls = 'true';
          const visibleCardIndex = () => {
            const cards = Array.from(grid.children);
            const index = cards.findIndex((card) => card.offsetLeft + card.offsetWidth > grid.scrollLeft + 8);
            return index >= 0 ? index : cards.length - 1;
          };
          nextArrow.addEventListener('click', () => {
            const cards = Array.from(grid.children);
            const next = cards[visibleCardIndex() + 1];
            grid.scrollTo({ left: next ? targetFor(next) : grid.scrollWidth, behavior: 'smooth' });
          });
          previousArrow.addEventListener('click', () => {
            const cards = Array.from(grid.children);
            const previous = cards[Math.max(0, visibleCardIndex() - 1)];
            grid.scrollTo({ left: targetFor(previous), behavior: 'smooth' });
          });
          grid.addEventListener('scroll', syncArrows, { passive: true });
          window.addEventListener('resize', positionArrows);
        }
        positionArrows();
        syncArrows();
      }
    }

    const callout = Array.from(section.querySelectorAll('div')).find((candidate) => Array.from(candidate.children).some((child) => child.tagName === 'P' && /Se voc[eê] se identifica com alguma dessas situações/i.test(normaliseText(child.textContent))));
    if (callout) callout.dataset.dfSituationsCallout = 'true';
  };

  const ensureSolutionsGrid = () => {
    const currentRoot = getRoot();
    const section = Array.from(currentRoot?.querySelectorAll('section') || []).find((candidate) => /Como o Dermafix ajuda a resolver isso/i.test(normaliseText(candidate.textContent)));
    if (!section) return;
    section.dataset.dfSolutionsSection = 'true';
    section.dataset.dfSurface = 'white';

    const grid = Array.from(section.querySelectorAll('div')).find((candidate) => {
      const children = Array.from(candidate.children);
      return children.length === 4 && children.every((child) => child.querySelector('h3'));
    });
    if (!grid) return;
    grid.dataset.dfSolutionsGrid = 'true';
    Array.from(grid.children).slice(3).forEach((card) => card.remove());
    Array.from(grid.children).forEach((card, index) => {
      card.dataset.dfSolutionCard = String(index + 1);
    });
  };

  const ensureProtocolTimeline = () => {
    const currentRoot = getRoot();
    const section = Array.from(currentRoot?.querySelectorAll('section') || []).find((candidate) => /PROTOCOLO DE USO/i.test(normaliseText(candidate.textContent)));
    if (!section) return;
    section.dataset.dfProtocolSection = 'true';
    section.dataset.dfSurface = 'soft';

    const steps = Array.from(section.querySelectorAll('div')).find((candidate) => {
      const children = Array.from(candidate.children);
      return children.length === 4 && children.every((child) => child.querySelector('h3') && child.querySelector('p'));
    });
    if (!steps) return;
    steps.dataset.dfProtocolSteps = 'true';

    const protocolImages = [
      {
        src: 'https://cdn.shopify.com/s/files/1/0838/5347/6113/files/passo01dermafix.webp?v=1789872981',
        alt: 'Imagem do passo 01 do protocolo Dermafix'
      },
      {
        src: 'https://cdn.shopify.com/s/files/1/0838/5347/6113/files/passo02dermafix.webp?v=1789872981',
        alt: 'Imagem do passo 02 do protocolo Dermafix'
      },
      {
        src: 'https://cdn.shopify.com/s/files/1/0838/5347/6113/files/passo_03_dermafix.webp?v=1789872981',
        alt: 'Imagem do passo 03 do protocolo Dermafix'
      },
      {
        src: 'https://cdn.shopify.com/s/files/1/0838/5347/6113/files/passo_04_dermafix.webp?v=1789872981',
        alt: 'Imagem do passo 04 do protocolo Dermafix'
      }
    ];

    Array.from(steps.children).forEach((card, index) => {
      const stepImage = protocolImages[index];
      if (card.dataset.dfProtocolStep === 'true') {
        const media = card.querySelector('.df-protocol-step__media');
        const image = media?.querySelector('[data-df-protocol-image="true"]');
        if (media && stepImage && image) {
          image.src = stepImage.src;
          image.alt = stepImage.alt;
          media.dataset.dfStepImage = 'true';
          media.removeAttribute('data-df-placeholder-image');
          media.setAttribute('aria-label', stepImage.alt);
        }
        return;
      }
      const originalBody = card.querySelector('.flex.items-start');
      const number = normaliseText(originalBody?.querySelector('span')?.textContent) || String(index + 1).padStart(2, '0');
      const title = normaliseText(originalBody?.querySelector('h3')?.textContent) || `Passo ${number}`;
      const description = normaliseText(originalBody?.querySelector('p')?.textContent);

      const media = document.createElement('div');
      media.className = 'df-protocol-step__media';
      media.dataset.dfStepImage = 'true';
      media.setAttribute('aria-label', stepImage?.alt || `Imagem do passo ${number}`);
      const image = document.createElement('img');
      image.dataset.dfProtocolImage = 'true';
      image.src = stepImage?.src || '';
      image.alt = stepImage?.alt || `Imagem do passo ${number} do protocolo Dermafix`;
      image.width = 640;
      image.height = 480;
      image.loading = 'lazy';
      image.decoding = 'async';
      media.append(image);

      const body = document.createElement('div');
      body.className = 'df-protocol-step__body';
      const meta = document.createElement('div');
      meta.className = 'df-protocol-step__meta';
      const badge = document.createElement('span');
      badge.className = 'df-protocol-step__number';
      badge.textContent = number;
      const label = document.createElement('span');
      label.className = 'df-protocol-step__label';
      label.textContent = 'PASSO';
      meta.append(badge, label);
      const heading = document.createElement('h3');
      heading.className = 'df-protocol-step__title';
      heading.textContent = title;
      const copy = document.createElement('p');
      copy.className = 'df-protocol-step__copy';
      copy.textContent = description;
      body.append(meta, heading, copy);

      card.dataset.dfProtocolStep = 'true';
      card.setAttribute('aria-label', `Passo ${number}: ${title}`);
      card.replaceChildren(media, body);
    });

    const closing = Array.from(section.querySelectorAll('div')).find((candidate) => Array.from(candidate.children).some((child) => /^(H3|P)$/i.test(child.tagName) && /N[aã]o [eé] sobre passar um creme/i.test(normaliseText(child.textContent))));
    if (closing) closing.remove();
  };

  const ensureComparisonRevamp = () => {
    const currentRoot = getRoot();
    const section = Array.from(currentRoot?.querySelectorAll('section') || []).find((candidate) => /Por que escolher o Dermafix/i.test(normaliseText(candidate.textContent)));
    if (!section) return;
    section.dataset.dfComparisonLegacy = 'true';
    section.removeAttribute('data-df-comparison-revamp');
    section.removeAttribute('data-df-surface');
    return;

    if (section.dataset.dfComparisonRevamp === 'true') return;

    const currentRows = Array.from(section.querySelectorAll('table tbody tr')).map((row) => {
      const cells = Array.from(row.children);
      return {
        label: normaliseText(cells[0]?.textContent),
        ours: Boolean(cells[1]?.querySelector('.lucide-check')),
        other: Boolean(cells[3]?.querySelector('.lucide-check'))
      };
    }).filter((row) => row.label);
    const rows = currentRows.length ? currentRows : [
      { label: 'Redução da aparência da celulite', ours: true, other: false },
      { label: 'Melhora da firmeza da pele', ours: true, other: true },
      { label: 'Auxílio na circulação local', ours: true, other: false },
      { label: 'Resultados visíveis em semanas', ours: true, other: false },
      { label: 'Sensação de pernas mais leves', ours: true, other: false },
      { label: 'Hidratação profunda', ours: true, other: true }
    ];

    const makeCell = (className, text, role = 'cell') => {
      const cell = document.createElement('div');
      cell.className = className;
      cell.setAttribute('role', role);
      if (text) cell.textContent = text;
      return cell;
    };

    const makeStatus = (available, label) => {
      const cell = makeCell(`df-comparison-cell ${available ? 'df-comparison-cell--yes' : 'df-comparison-cell--no'}`, '', 'cell');
      const icon = document.createElement('span');
      icon.className = 'df-comparison-status';
      icon.setAttribute('aria-label', `${label}: ${available ? 'sim' : 'não'}`);
      icon.textContent = available ? '✓' : '×';
      cell.append(icon);
      return cell;
    };

    const inner = document.createElement('div');
    inner.className = 'df-comparison-inner';
    const eyebrow = document.createElement('p');
    eyebrow.className = 'df-comparison-eyebrow';
    eyebrow.textContent = 'NÓS VS ELES';
    const heading = document.createElement('h2');
    heading.className = 'df-comparison-heading';
    heading.textContent = 'COMO SOMOS DIFERENTES?';
    const intro = document.createElement('p');
    intro.className = 'df-comparison-intro';
    intro.textContent = 'Por que o Dermafix se destaca de outras soluções?';
    const grid = document.createElement('div');
    grid.className = 'df-comparison-grid';
    grid.setAttribute('role', 'table');
    grid.setAttribute('aria-label', 'Comparação entre Dermafix e outras soluções');

    const header = document.createElement('div');
    header.className = 'df-comparison-row df-comparison-row--header';
    header.setAttribute('role', 'row');
    header.append(
      makeCell('df-comparison-label df-comparison-label--header', '', 'columnheader'),
      makeCell('df-comparison-cell df-comparison-cell--header df-comparison-cell--ours', 'DERMAFIX', 'columnheader'),
      makeCell('df-comparison-cell df-comparison-cell--header df-comparison-cell--other', 'OUTRAS SOLUÇÕES', 'columnheader')
    );
    grid.append(header);

    rows.forEach((row) => {
      const line = document.createElement('div');
      line.className = 'df-comparison-row';
      line.setAttribute('role', 'row');
      line.append(makeCell('df-comparison-label', row.label), makeStatus(row.ours, 'Dermafix'), makeStatus(row.other, 'Outras soluções'));
      grid.append(line);
    });

    const cta = document.createElement('a');
    cta.className = 'df-comparison-cta';
    cta.href = '#hero-purchase';
    cta.textContent = 'ADICIONAR AO CARRINHO';
    inner.append(eyebrow, heading, intro, grid, cta);
    section.replaceChildren(inner);
    section.dataset.dfComparisonRevamp = 'true';
    section.dataset.dfSurface = 'soft';
  };

  const markSurfaceRhythm = () => {
    const currentRoot = getRoot();
    if (!currentRoot) return;
    const surfaces = [
      { pattern: /FÓRMULA SUPERIOR/i, value: 'soft' },
      { pattern: /Sua Jornada de Transformação/i, value: 'white' },
      { pattern: /Diferenciais e Ativos/i, value: 'soft' },
      { pattern: /INVESTIMENTO EM VOCÊ/i, value: 'white' },
      { pattern: /Avaliações dos Clientes/i, value: 'soft' }
    ];
    Array.from(currentRoot.querySelectorAll('section')).forEach((section) => {
      const text = normaliseText(section.textContent);
      const surface = surfaces.find((item) => item.pattern.test(text));
      if (surface) {
        section.dataset.dfSurface = surface.value;
        if (/Sua Jornada de Transforma/i.test(text)) section.dataset.dfJourneySection = 'true';
      }
    });
  };

  const ensureTransformationShowcase = () => {
    const currentRoot = getRoot();
    if (!currentRoot || currentRoot.querySelector('[data-df-transformation-showcase="true"]')) return;

    const section = Array.from(currentRoot.querySelectorAll('section')).find((candidate) => {
      const text = normaliseText(candidate.textContent);
      return /2 minutos por dia/i.test(text)
        && candidate.querySelectorAll('img[alt="Antes"]').length >= 4
        && candidate.querySelectorAll('img[alt="Depois"]').length >= 4;
    });
    if (!section) return;

    section.dataset.dfTransformationShowcase = 'true';
    const heading = section.querySelector('h2');
    if (heading) {
      heading.classList.add('df-transform-heading');
      heading.innerHTML = '<span class="df-transform-heading__accent">A TRANSFORMAÇÃO QUE VOCÊ QUER</span><span>ESTÁ AQUI!</span>';
    }

    const intro = heading?.parentElement?.querySelector('p');
    if (intro) {
      intro.classList.add('df-transform-intro');
      intro.textContent = 'Pares visuais para apresentar a evolução da aparência da pele.';
    }

    const labels = [
      'Aparência da celulite',
      'Sensação de leveza e inchaço',
      'Aparência de estrias',
      'Firmeza e textura da pele'
    ];
    const cards = Array.from(section.querySelectorAll('img[alt="Antes"]'))
      .map((image) => image.closest('.relative.bg-gray-50'))
      .filter(Boolean)
      .slice(0, 4);
    const cardGrid = cards[0]?.parentElement;
    cardGrid?.classList.add('df-transform-grid');
    cardGrid?.setAttribute('data-df-transform-grid', 'true');

    cards.forEach((card, index) => {
      card.dataset.dfTransformCard = 'true';
      card.setAttribute('aria-label', `Visual de referência ${index + 1}: ${labels[index]}`);

      const badge = card.querySelector('.absolute');
      badge?.remove();

      const caption = card.querySelector('.bg-orange-500 p');
      if (caption) caption.textContent = labels[index];

      const afterLabel = Array.from(card.querySelectorAll('span')).find((element) => /DEPOIS/i.test(element.textContent || ''));
      if (afterLabel) afterLabel.textContent = 'DEPOIS';

      card.querySelectorAll('img').forEach((image) => {
        image.loading = 'lazy';
        image.setAttribute('data-df-placeholder-image', 'true');
      });
    });

    const note = Array.from(section.querySelectorAll('p')).find((element) => /Resultados podem variar/i.test(element.textContent || ''));
    note?.remove();

    const content = section.querySelector('.max-w-6xl') || section.firstElementChild || section;
    if (!content.querySelector('[data-df-transform-cta="true"]')) {
      const ctaWrap = document.createElement('div');
      ctaWrap.dataset.dfTransformCta = 'true';
      ctaWrap.className = 'df-transform-cta-wrap';
      ctaWrap.innerHTML = '<a class="df-transform-cta df-section-cta" href="#hero-purchase">ADICIONAR AO CARRINHO</a>';
      content.append(ctaWrap);
    }
  };

  const ensureSectionCtas = () => {
    const currentRoot = getRoot();
    if (!currentRoot) return;

    Array.from(currentRoot.querySelectorAll('section')).forEach((section) => {
      if (section.id === 'hero-section' || section.dataset.dfPressSection === 'true' || section.querySelector('#hero-purchase')) return;
      if (!section.querySelector('h2, h3')) return;

      const existing = section.querySelector('[data-df-transform-cta="true"] a, [data-df-section-cta="true"], .df-comparison-cta');
      if (existing) {
        existing.classList.add('df-section-cta');
        existing.dataset.dfSectionCta = 'true';
        existing.textContent = 'ADICIONAR AO CARRINHO';
        existing.setAttribute('href', '#hero-purchase');
        return;
      }

      const host = section.querySelector('[data-df-situations-callout="true"]')?.parentElement
        || section.querySelector('[data-df-protocol-closing="true"]')?.parentElement
        || section.querySelector('.max-w-6xl')
        || section.firstElementChild
        || section;
      const cta = document.createElement('a');
      cta.className = 'df-section-cta';
      cta.dataset.dfSectionCta = 'true';
      cta.href = '#hero-purchase';
      cta.textContent = 'ADICIONAR AO CARRINHO';
      cta.setAttribute('aria-label', 'Adicionar o Dermafix ao carrinho');
      host.append(cta);
    });
  };

  const removeHeroBonusStrip = () => {
    const banner = Array.from(root.querySelectorAll('#hero-section *')).find((element) => {
      const text = normaliseText(element.textContent);
      if (!/Faça seu pedido até hoje/i.test(text) || element.closest('#hero-purchase')) return false;
      return !Array.from(element.querySelectorAll('*')).some((child) => /Faça seu pedido até hoje/i.test(normaliseText(child.textContent)));
    });
    banner?.remove();
  };

  const restoreGiftDetails = () => {
    root.querySelectorAll('[data-df-gift-details="true"]').forEach((details) => {
      details.removeAttribute('data-df-gift-details');
      details.removeAttribute('aria-hidden');
    });
  };

  const syncVariantOffer = () => {
    const currentRoot = getRoot();
    const purchase = currentRoot?.querySelector('#hero-purchase');
    if (!currentRoot || !purchase) return;

    removeSpatulaCard();
    currentRoot.querySelectorAll('#hero-purchase [data-df-buy] svg').forEach((icon) => icon.remove());
    replaceMockOfferPrices();
    replaceMockProductWeight();
    restoreGiftPill();
    hidePostPurchaseProof();
    ensureShippingPriorityIcon();
    hidePurchaseFeedback();

    const onePotSelected = purchase.querySelector('input[type="radio"][value="1"]')?.checked === true;
    const previousHidden = Array.from(purchase.querySelectorAll('[data-df-one-pot-freight="true"]'));
    previousHidden.forEach((element) => {
      element.hidden = false;
      element.removeAttribute('aria-hidden');
      element.style.removeProperty('display');
      element.removeAttribute('data-df-one-pot-freight');
    });

    if (!onePotSelected) return;

    const freightItems = Array.from(purchase.querySelectorAll('li, span, p')).filter((element) => {
      return /^frete grátis$/i.test(normaliseText(element.textContent));
    });
    freightItems.forEach((element) => {
      const target = element.closest('li') || element;
      target.dataset.dfOnePotFreight = 'true';
      target.hidden = true;
      target.setAttribute('aria-hidden', 'true');
      target.style.setProperty('display', 'none', 'important');
    });
  };

  let variantRefreshTimers = [];
  const scheduleVariantOfferRefresh = () => {
    variantRefreshTimers.forEach((timer) => window.clearTimeout(timer));
    variantRefreshTimers = [0, 120, 400, 900].map((delay) => window.setTimeout(syncVariantOffer, delay));
  };

  let offerObserver = null;
  const setupVariantOfferObserver = () => {
    const currentRoot = getRoot();
    if (!currentRoot) return;
    offerObserver?.disconnect();
    offerObserver = new MutationObserver((mutations) => {
      const purchaseChanged = mutations.some((mutation) => {
        const target = mutation.target?.nodeType === Node.ELEMENT_NODE ? mutation.target : mutation.target?.parentElement;
        if (target?.closest?.('#hero-purchase')) return true;
        return Array.from(mutation.addedNodes || []).some((node) => {
          return node.nodeType === Node.ELEMENT_NODE && (node.matches?.('#hero-purchase') || node.querySelector?.('#hero-purchase'));
        });
      });
      if (purchaseChanged) scheduleVariantOfferRefresh();
    });
    offerObserver.observe(currentRoot, { childList: true, subtree: true });
  };

  const enhanceHero = () => {
    ensureStorePromoBar();
    ensureHeroCopy();
    ensureKoreanSeal();
    hidePostPurchaseProof();
    ensureShippingPriorityIcon();
    hidePurchaseFeedback();
    ensureHeroVisual();
    ensurePressBar();
    ensureSituationsGrid();
    ensureSolutionsGrid();
    ensureAssetsFeature();
    ensureIngredientCarousel();
    ensureAccordionScrollGuard();
    ensureProtocolTimeline();
    ensureComparisonRevamp();
    ensureTransformationShowcase();
    markSurfaceRhythm();
    ensureSectionCtas();
    root.querySelectorAll('#hero-purchase [data-df-buy] svg').forEach((icon) => icon.remove());
    replaceMockOfferPrices();
    replaceMockProductWeight();
    rewriteInvestmentCallout();
    ensureReviewsBeforeAssets();
    setupStickyProductMedia();
    removeHeroBonusStrip();
    restoreGiftDetails();
  };

  const restoreGiftPill = () => {
    const giftText = 'e-book grátis no seu pedido';
    root.querySelectorAll('span.inline-block.font-bold.text-white.rounded-full').forEach((pill) => {
      if (!/brindes grátis/i.test(pill.textContent || '') && !pill.closest('#hero-purchase')) return;
      pill.classList.add('df-gift-pill');
      if (pill.textContent.trim() !== giftText) pill.textContent = giftText;
      pill.style.setProperty('color', '#ffffff', 'important');
      pill.style.setProperty('-webkit-text-fill-color', '#ffffff', 'important');
      pill.style.setProperty('text-indent', '0', 'important');
    });
  };

  const hidePurchaseFeedback = () => {
    const currentRoot = getRoot();
    if (!currentRoot) return;

    currentRoot.querySelectorAll('[data-df-cart-status]').forEach((status) => status.remove());
    const discountLabel = Array.from(currentRoot.querySelectorAll('span'))
      .find((element) => /^DESCONTO APLICADO AUTOMATICAMENTE$/i.test(normaliseText(element.textContent)));
    const discountRow = discountLabel?.parentElement;
    const discountGroup = discountRow?.parentElement;
    if (discountGroup?.querySelector('[data-df-hidden-proof="true"]')) discountGroup.remove();
    else discountRow?.remove();
  };

  const removeFavorite = () => {
    root.querySelectorAll('button').forEach((button) => {
      if (button.querySelector('svg.lucide-heart')) button.remove();
    });
  };

  const setupInstantCart = () => {
    const purchase = root.querySelector('#hero-purchase');
    if (!purchase || root.dataset.dfInstantBound === 'true') return;
    root.dataset.dfInstantBound = 'true';
    const clearCartStatus = () => {
      root.querySelectorAll('[data-df-cart-status]').forEach((status) => status.remove());
    };
    const getQuantity = () => {
      const currentPurchase = root.querySelector('#hero-purchase') || purchase;
      const checked = currentPurchase.querySelector('input[type="radio"]:checked');
      if (['1','2','3'].includes(checked?.value)) return Number(checked.value);
      return /3\s+potes/i.test(currentPurchase.textContent) ? 3 : 1;
    };
    const waitForApi = (attempt = 0) => new Promise((resolve) => {
      /* Sacola própria do site (sem Instant desde 30/10) */
      if (window.AttrCart) return resolve(window.AttrCart ? { addToCart: (item) => window.AttrCart.add([{ id: item.id, quantity: item.quantity, properties: { '_attr-origem': 'dermafix' } }]) } : null);
      if (attempt >= 20) return resolve(null);
      window.setTimeout(() => resolve(waitForApi(attempt + 1)), 250);
    });
    root.addEventListener('click', async (event) => {
      if (!(event.target instanceof Element)) return;
      const button = event.target.closest('[data-df-buy]');
      if (!button || !root.contains(button)) return;
      event.preventDefault();
      event.stopPropagation();
      const quantity = getQuantity();
      const variantId = Number(window.DF_VARIANT_ID);
      clearCartStatus();
      button.dataset.dfState = 'pending';
      const api = await waitForApi();
      if (!api) {
        delete button.dataset.dfState;
        return;
      }
      try {
        const result = await api.addToCart({ id: variantId, quantity }, { openCart: true });
        if (result && result.success === false) throw new Error('Instant addToCart returned success=false');
      } catch (error) {
        delete button.dataset.dfState;
        console.warn('[Dermafix] Instant Cart bridge failed', error);
      } finally {
        delete button.dataset.dfState;
      }
    });
  };

  const hasHeroAndPurchase = () => {
    const currentRoot = getRoot();
    return Boolean(currentRoot?.querySelector('#hero-section') && currentRoot?.querySelector('#hero-purchase'));
  };
  let applyTimer = null;

  const applyDermafixAdjustments = () => {
    const currentRoot = getRoot();
    if (!currentRoot || !hasHeroAndPurchase()) return;
    if (currentRoot.dataset.dfAdjustmentsApplied === 'true') {
      rewriteInvestmentCallout();
      ensureReviewsBeforeAssets();
      return;
    }
    currentRoot.dataset.dfGalleryReady = 'false';
    ensureDermafixOffers();
    removeLegacyChrome();
    removeShareButton();
    const galleryReady = rebuildGallery();
    replaceText();
    replaceBrandAttributes();
    replaceReviewsSummary();
    restoreGiftPill();
    removeFavorite();
    removeSpatulaCard();
    hideWomenVideos();
    enhanceHero();
    syncVariantOffer();
    setupInstantCart();

    currentRoot.addEventListener('change', () => {
      restoreGiftDetails();
      scheduleVariantOfferRefresh();
    }, true);
    setupVariantOfferObserver();
    currentRoot.dataset.dfAdjustmentsApplied = 'true';
    if (galleryReady) currentRoot.dataset.dfGalleryReady = 'true';
  };

  const scheduleApply = () => {
    const currentRoot = getRoot();
    if (!currentRoot || !hasHeroAndPurchase()) return;
    if (currentRoot.dataset.dfAdjustmentsApplied === 'true') return;
    currentRoot.dataset.dfAdjustmentsApplied = 'false';
    currentRoot.dataset.dfGalleryReady = 'false';
    window.clearTimeout(applyTimer);
    applyTimer = window.setTimeout(applyDermafixAdjustments, 0);
  };

  const observer = new MutationObserver(scheduleApply);
  if (document.body) observer.observe(document.body, { childList: true, subtree: true });
  else document.addEventListener('DOMContentLoaded', () => observer.observe(document.body, { childList: true, subtree: true }), { once: true });
  [0, 500, 1500].forEach((delay) => window.setTimeout(applyDermafixAdjustments, delay));
  scheduleApply();
})();
